import {
  getLockValue,
  getPositioningOption,
  getShadowFabricInstance,
  removeObjectFromCanvas,
  removeRepeatingLinkParams
} from '@frontend/utils';
import { IMAGE_FROM_BK_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { fabric } from 'fabric';

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data', 'getIsLightweight']);

export function drawImageFromBackground({
   fields,
   positioning_options,
   data,
   canvas,
   id,
   shadows,
   dimension,
   isApplyToAll
}) {
  const { canvas_data, getIsLightweight } = getScopePage();
  canvas_data[id].imgFromBkCoords = [];
  removeObjectFromCanvas(canvas, IMAGE_FROM_BK_PREFIX_ID);

  return Promise.all(
    canvas_data[id].img_from_bk.map(
      (b, i) =>
        new Promise((resolve, reject) => {
          if (!data.img_from_bk || data.img_from_bk.length === 0) {
            resolve();
            return;
          }
          
          let url = data.img_from_bk[i];
          let dimension_width = b['width'];
          const offset_x = 
            data.img_from_bk_offset_x ? +data.img_from_bk_offset_x[i] : data.img_from_bk_offset_y[i];
          const offset_y = parseFloat(data.img_from_bk_offset_y[i]);
          const scale = parseFloat(data.img_from_bk_scale[i]);
          
          // patch for older layouts in which the vertical scale did not exist
          let scale_y = data.img_from_bk_scale_y ? parseFloat(data.img_from_bk_scale_y[i]) : scale;
          const positioningOption = getPositioningOption(positioning_options, data, fields, b);
          
          let left = b['left'] + dimension[4].x;
          let top = b['top'] + dimension[4].y;
          if (positioningOption) {
            left = positioningOption.x == null ? left : positioningOption.x;
            top = positioningOption.y == null ? top : positioningOption.y;
            dimension_width = positioningOption.width == null ? dimension_width : positioningOption.width;
          }
          // replace domain name from URL POR-2222
          if (url && url.includes('share?file=')) {
            url = removeRepeatingLinkParams(url, '&full_resolution');
          }

          const is_lightweight = getIsLightweight();

          fabric.Image.fromURL(url, function (oImg) {
            const config = {
              id: IMAGE_FROM_BK_PREFIX_ID + i,
              element_id: IMAGE_FROM_BK_PREFIX_ID + i,
              groupName: b['Group Name'],
              order: b['order'],
              left: canvas_data[id].spacingFieldPosition[b.name]
                ? canvas_data[id].spacingFieldPosition[b.name].x
                : left + offset_x,
              top: top + offset_y,
              originX: 'left',
              originY: 'top',
              selectable: b['moveable'],
              evented: b['moveable'],
              isApplyToAll
            };
            oImg.set(config);
            oImg.scaleToWidth(dimension_width * scale);
            oImg.set({ scaleY: oImg.scaleY / scale * scale_y });
            const bShadow = +canvas_data[id]?._data?.[`img_from_bk_shadow`]?.[i];
            oImg.set({ shadow: getShadowFabricInstance(id, oImg.element_id, shadows, bShadow, oImg.scaleX, oImg.scaleY) });
            oImg.set({ locked: getLockValue(id, oImg.element_id) });

            canvas.add(oImg);

            canvas_data[id].imgFromBkCoords.push({
              x: oImg.left - offset_x,
              y: oImg.top - offset_y,
              scaleX: oImg.scaleX / scale,
            });
            
            resolve();
          });
        })
    )
  );
}